import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/index.scss' // global css
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import parseTime from './utils'

Vue.prototype.$parseTime = parseTime
Vue.use(Element, {
  size: 'medium' // set element-ui default size
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
